module.exports = __webpack_public_path__ + "static/media/kke.7e679664.mp3";